import { render } from "./VInputCheckbox.vue?vue&type=template&id=68bb8ece&scoped=true"
import script from "./VInputCheckbox.vue?vue&type=script&lang=js"
export * from "./VInputCheckbox.vue?vue&type=script&lang=js"

import "./VInputCheckbox.vue?vue&type=style&index=0&id=68bb8ece&scoped=true&lang=css"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bb8ece"]])

export default __exports__